import React from 'react'
import { useContent } from '../../contexts/ContentContext'
import TestimonialsSection from './TestimonialsSection'
import TestimonialCarousel from './TestimonialCarousel'

/**
 * TestimonialView - Responsive testimonial display
 *
 * MOBILE (<768px): TestimonialsSection (Grid) - All testimonials visible at once
 * DESKTOP (≥768px): TestimonialCarousel (Slider) - Auto-advancing carousel
 *
 * This approach provides better mobile UX by showing all content upfront
 * without requiring swipe gestures, while preserving desktop carousel experience.
 */
export default function TestimonialView() {
  const { testimonials } = useContent()

  return (
    <div id="testimonials" data-testid="testimonial-view">
      {/* Mobile: TestimonialsSection (Grid) */}
      <div className="md:hidden">
        <TestimonialsSection />
      </div>

      {/* Desktop: TestimonialCarousel (Slider) */}
      <div className="hidden md:block">
        <TestimonialCarousel
          clients={testimonials?.clients || []}
          label={testimonials?.clientLabel || ''}
          subtitle={testimonials?.clientSubtitle || ''}
        />
      </div>
    </div>
  )
}
